import Status from '@/status'
import store from '@/store/index'
export default {
  name: 'create',
  components: {},
  props: [],
  data () {
    return {
      checklist_item: {},
      normalizer (node) {
        return {
          id: node.id,
          label: node.index +'. '+ node.header,
          // children: node.children ? node.children : null
        }
      },
      config_doc (node) {
        return {
          id: node.id,
          label: node.name +' - v'+ node.version,
          loadOptions: node.children ? node.children : null
        }
      },
      config_tag (node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      config: {
      },
      loading: false,
      btn_create: false,
      errors: {},
      document_items: []
    }
  },
  computed: {
    
    documents () {
      return this.$store.getters['Document/getListDocument']
    },
    tags () {
      return this.$store.getters['Tag/getListTag']
    }
  },
  mounted () {
  
    this.loading = true
    this.btn_create = true
    Promise.all([
      this.$store.dispatch('Document/getListDocument', {page: 1, per_page: 'all', status: Status.APPROVAL}),
      this.$store.dispatch('Tag/getListTag', {page: 1, per_page: 'all'})
    ]).then(res => {
      
      this.btn_create = false
      this.loading = false
    }).catch(errors => {
      
      this.btn_create = false
      this.loading = false
    })
  },
  methods: {
    show (group, header) {
      this.checklist_item.grp_chk_item_id = group.id
      this.checklist_item.header = header
      this.checklist_item.si = false
      this.errors = {}
      this.$refs.createModal.show()
    },
    selectDoc (node, instanceId) {
      this.document_items = []
    
      this.$store.dispatch('DocumentItem/getListDocumentItem', {document: node}).then(res => {
        this.document_items = this.$store.getters['DocumentItem/getListDocumentItem']
        // console.log(this.document_items);
        
      }).catch(errors => {
        console.log(errors)
        
      })
    },
    create () {
    
      this.btn_create = true
      this.$store.dispatch('ChecklistItem/createChecklistItem', {checklist_item: this.checklist_item}).then(res => {
        
        this.btn_create = false
        this.checklist_item = {}
        this.checklist_item.content = ''
        this.errors = {}
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
        this.$refs.createModal.hide()
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        
        this.btn_create = false
      })
    },
    UploadAdapter (loader) {
      this.loader = loader
      this.upload = function () {
        const body = new FormData()
        body.append('image', this.loader.file)
        return store.dispatch('ChecklistItem/uploadImage', {data: body})
          .then(downloadUrl => {
            return {
              default: downloadUrl
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist-item/create/create.js